<template>
  <button @click="toggleTheme" class="themeSwitch" :aria-label="$t('message.toggleThemeLabel')">
    <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" :fill="iconTheme === 'light' ? '#FFFFFF' : '#000000'">
      <path d="M0 0h24v24H0z" fill="none"/><path d="M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-.89 0-1.74-.2-2.5-.55C11.56 16.5 13 14.42 13 12s-1.44-4.5-3.5-5.45C10.26 6.2 11.11 6 12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"/>
    </svg>
  </button>
</template>
<script>
  import Vue from 'vue'
  import VueI18n from 'vue-i18n'
  import eventTracker from '../services/eventTracker'

  const messages = {
    en: {
      message: {
        toggleThemeLabel: 'Change theme'
      }
    },
    hi: {
      message: {
        toggleThemeLabel: 'थीम बदलें'
      }
    }
  }

  Vue.use(VueI18n)

  const i18n = new VueI18n({
    locale: typeof (Storage) !== 'undefined' ? localStorage.getItem('userLang') ? localStorage.getItem('userLang') : 'en' : 'en',
    messages: messages
  })

  export default {
    i18n,
    data () {
      return {
        lang: typeof (Storage) !== 'undefined' ? localStorage.getItem('userLang') ? localStorage.getItem('userLang') : 'en' : 'en'
      }
    },
    props: {
      iconTheme: {
        type: String,
        default: 'dark'
      },
      userLang: {
        type: String,
        default: 'en'
      }
    },
    methods: {
      toggleTheme () {
        const currentTheme = typeof (Storage) !== 'undefined' ? localStorage.getItem('theme') : undefined
        let newTheme = currentTheme
          ? currentTheme === 'dark' ? 'light' : 'dark'
          : window.matchMedia('(prefers-color-scheme: dark)').matches ? 'light' : 'dark'
        document.documentElement.setAttribute('data-theme', newTheme)
        eventTracker.trackThemeChange(newTheme)
        this.$emit('themeChanged', newTheme)
        if (typeof (Storage) !== 'undefined') {
          localStorage.setItem('theme', newTheme)
        }
      }
    },
    watch: {
      userLang: function (newVal) {
        i18n.locale = newVal
      }
    }
  }
</script>

<style scoped>
  .themeSwitch {
    padding: 5px;
    border-radius: 50%;
    background-color: transparent;
    border: none;
    margin-right: 5px;
    cursor: pointer;
  }

  .themeSwitch:hover, .themeSwitch:focus {
    background-color: rgba(255, 255, 255, 0.1);
  }
</style>


// WEBPACK FOOTER //
// src/components/ThemeSwitcher.vue